import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Typography } from "@mui/material";
import Section from "../../components/about/Section";
import ResponsiveImage from "../../components/about/ResponsiveImage";

const TaskSearch = () => {
  return (
    <Page className="about-page task-search-page" pageKey="task-search">
      <AboutTemplate>
        <Typography variant="h1">Task search</Typography>
        <Section>
          <Typography variant="body1">
            Task search is a way to find a specific task in your stack.
          </Typography>
          <Typography variant="body1">
            You can search for a task by clicking the search icon at the top
            right of your task list header, next to the Sort and Filter
            controls.
          </Typography>
          <ResponsiveImage
            pageKey="taskSearch"
            imageName="search-icon"
            size="large"
          />
        </Section>
        <Section>
          <Typography variant="body1">
            Clicking the search icon will open a search bar at the top of your
            task stack.
          </Typography>
          <ResponsiveImage
            pageKey="taskSearch"
            imageName="search-bar"
            size="large"
          />
        </Section>
        <Section>
          <Typography variant="body1">
            Type in the search bar to find tasks by their title. Your task stack
            will update in real time to only show tasks which match the search
            term.
          </Typography>
          <ResponsiveImage
            pageKey="taskSearch"
            imageName="search-results"
            size="large"
          />
        </Section>
        <Section title="Closing the search">
          <Typography variant="body1">
            You can close the search bar by clicking the X button inside the
            search bar, or by pressing the Escape key. This will clear the
            search and show all of your tasks again.
          </Typography>
        </Section>
      </AboutTemplate>
    </Page>
  );
};

export default TaskSearch;
